import { render, staticRenderFns } from "./final_book_shop_table.vue?vue&type=template&id=492409b2&lang=pug&"
import script from "./final_book_shop_table.vue?vue&type=script&lang=js&"
export * from "./final_book_shop_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports